import { c as _c } from "react/compiler-runtime";
import Grid from '@precis-digital/kurama/Grid';
import Typography from '@precis-digital/kurama/Typography';
import { useTheme } from '@precis-digital/kurama/utils';
import ThemedImage from 'shared/components/Themed/Image';
import rubikIcon from 'public/assets/images/rubik.svg';
import { type TFunction } from 'shared/translations';
const ReportDataLoading = t0 => {
  const $ = _c(20);
  const {
    t
  } = t0;
  const theme = useTheme();
  let t1;
  if ($[0] !== theme) {
    t1 = theme.spacing(3);
    $[0] = theme;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== theme) {
    t2 = theme.spacing(5);
    $[2] = theme;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ThemedImage src={rubikIcon.src} alt="rubik" width={120} height={120} sizes="20vw" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("dataLoadingTitle");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <Typography variant="h5">{t4}</Typography>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t("dataLoadingDescription");
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <Typography variant="body3">{t6}</Typography>;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t5 || $[14] !== t7) {
    t8 = <Grid container={true} direction="column" alignItems="center">{t5}{t7}</Grid>;
    $[13] = t5;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t1 || $[17] !== t2 || $[18] !== t8) {
    t9 = <Grid container={true} direction="column" alignItems="center" justifyContent="center" paddingTop={t1} gap={t2}>{t3}{t8}</Grid>;
    $[16] = t1;
    $[17] = t2;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
};
export default ReportDataLoading;